
import React from 'react';
import { MentoriaOffering } from "@/hooks/useMentoriasAdmin";
import { MentoriasTable } from "./MentoriasTable";

interface MentoriasListProps {
  mentorias: MentoriaOffering[];
  searchTerm: string;
  onEdit: (mentoria: MentoriaOffering) => void;
  onViewDetails: (mentoria: MentoriaOffering) => void;
  onToggleStatus: (id: string, isActive: boolean) => void;
}

export const MentoriasList: React.FC<MentoriasListProps> = ({ 
  mentorias, 
  searchTerm, 
  onEdit, 
  onViewDetails,
  onToggleStatus 
}) => {
  return (
    <MentoriasTable
      mentorias={mentorias}
      searchTerm={searchTerm}
      onEdit={onEdit}
      onViewDetails={onViewDetails}
      onToggleStatus={onToggleStatus}
    />
  );
};
